<div class="ai-table" *transloco="let t; prefix: 'ai-assistant'">
  @if (hasData()) {
    <div class="ai-table__container">
      <table class="ai-table__grid">
        <thead>
          <tr>
            @for (col of columns(); track col.key) {
              <th class="ai-table__header">{{ col.label }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of rows(); track $index) {
            <tr class="ai-table__row">
              @for (col of columns(); track col.key) {
                <td class="ai-table__cell">{{ cellValue(row, col.key) }}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <div class="ai-table__empty">{{ t('table-no-data') }}</div>
  }
</div>
